// extracted by mini-css-extract-plugin
export default {"IOSPermissionButton":"styles_IOSPermissionButton__aNFob","body":"styles_body__qYyFf","buttonGang":"styles_buttonGang__l90I1"};